import { Button } from '@/shared/ui/Button';
import { Content, Screen } from '@/shared/ui/Layout';
import { TopBar } from '@/shared/ui/TopBar';
import { isChunkLoadError } from './chunkReload';

/**
 * What a screen shows when it throws instead of rendering.
 *
 * It distinguishes two causes because they need two different things from the person. A missing
 * chunk after a deploy is fixed by reloading, and saying so is honest and actionable. Anything
 * else is our bug, and a reload usually will not help — offering it as the only way out would be
 * a lie dressed as advice.
 */
export function RouteError({ error }: { error: Error }) {
  const stale = isChunkLoadError(error);

  return (
    <Screen>
      <TopBar title={stale ? 'Обновите страницу' : 'Что-то сломалось'} />
      <Content width="narrow" centered>
        <div className="flex flex-col gap-4 text-center">
          <p className="text-ink-soft">
            {stale
              ? 'Приложение обновилось, пока эта вкладка была открыта. Перезагрузите страницу — данные не потеряются.'
              : 'Экран не открылся. Попробуйте вернуться назад или перезагрузить страницу.'}
          </p>
          <Button onClick={() => window.location.reload()}>Перезагрузить</Button>
        </div>
      </Content>
    </Screen>
  );
}
